import { ILiteEvent } from './ILiteEvent';

export class LiteEvent<T> implements ILiteEvent<T> {
    private handlers: { (data?: T): void; }[] = [];

    public On(handler: { (data?: T): void }): void {
        this.handlers.push(handler);
    }

    public Off(handler: { (data?: T): void }): void {
        this.handlers = this.handlers.filter(h => h !== handler);
    }

    public Trigger(data?: T) {
        this.handlers.slice(0).forEach(h => h(data));
    }

    public Expose(): ILiteEvent<T> {
        return this;
    }
}